import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../services/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wire-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated,
})
export class LoaderComponent {
  loadingService = inject(LoadingService);

  images = [
    'assets/imgs/1.jpg',
    'assets/imgs/2.jpg',
    'assets/imgs/3.jpg',
    'assets/imgs/4.jpg',
    'assets/imgs/5.jpg',
    'assets/imgs/6.jpg',
    'assets/imgs/7.jpg',
  ];

  currentImage = this.images[0];
  private availableImages: string[] = [];
  private rotationInterval: any;
  progressValue = 0;
  private progressInterval: any;

  constructor(
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.loadingService.isLoadingSubject.subscribe({
      next: (isLoading) => {
        if (isLoading) {
          this.startImageRotation();
          this.startProgress();
        } else {
          this.resetImages();
          this.resetProgress();
        }
        this.cdr.detectChanges(); 
      },
      error: (err) => console.error('Loading error:', err)
    });
  }

  private startProgress() {
    this.progressValue = 0;
    this.progressInterval = setInterval(() => {
      if (this.progressValue < 100) {
        this.progressValue += 1;
        this.cdr.detectChanges();
      } else {
        clearInterval(this.progressInterval);
      }
    }, 30); // Adjust timing as needed
  }

  private resetProgress() {
    clearInterval(this.progressInterval);
    this.progressValue = 0;
    this.cdr.detectChanges();
  }

  private startImageRotation() {
    // Reset available images if empty
    if (this.availableImages.length === 0) {
      this.availableImages = [...this.images];
    }
    
    // Set initial random image
    this.currentImage = this.getRandomImage();

    this.rotationInterval = setInterval(() => {
      if (!this.loadingService.isLoadingSubject) {
        clearInterval(this.rotationInterval);
        return;
      }
      this.currentImage = this.getRandomImage();
      this.cdr.detectChanges();
    }, 1000);
  }

  private getRandomImage(): string {
    if (this.availableImages.length === 0) {
      this.availableImages = [...this.images];
    }
    
    const randomIndex = Math.floor(Math.random() * this.availableImages.length);
    const selectedImage = this.availableImages[randomIndex];
    
    // Remove the selected image from available images
    this.availableImages.splice(randomIndex, 1);
    
    return selectedImage;
  }

  private resetImages() {
    clearInterval(this.rotationInterval);
    this.availableImages = [];
    this.currentImage = this.images[0];
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    clearInterval(this.rotationInterval);
    clearInterval(this.progressInterval);
  }
}